import { render } from "./ExchangeInventory.vue?vue&type=template&id=204ea724"
import script from "./ExchangeInventory.vue?vue&type=script&lang=js"
export * from "./ExchangeInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__